var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveNotificationBgShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 142,
    viewBox: "0 0 249 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.92,
    clipPath: "url(#clip0_5014_35708)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_5014_35708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-32.5 36.9199C-24.8624 19.7657 -4.76462 12.0509 12.3896 19.6884L127.496 70.9373C172.905 91.1544 193.326 144.354 173.109 189.763L155.619 229.045C150.677 240.145 137.673 245.137 126.573 240.195L-43.3463 164.542C-64.5368 155.107 -74.0668 130.281 -64.6322 109.09L-32.5 36.9199Z",
    fill: "url(#paint0_linear_5014_35708)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_5014_35708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-41 128C-41 86.5786 -7.42135 53 34 53H94C135.421 53 169 86.5786 169 128V128C169 169.421 135.421 203 94 203H34C-7.42135 203 -41 169.421 -41 128V128Z",
    fill: "#776EFF",
    fillOpacity: 0.28
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_5014_35708",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-105.009 249.318C-118.232 212.989 -99.5006 172.82 -63.1722 159.598L54.2894 116.845C90.6179 103.623 130.787 122.354 144.009 158.682V158.682C157.232 195.011 138.501 235.18 102.172 248.402L-15.2894 291.155C-51.6179 304.377 -91.7868 285.646 -105.009 249.318V249.318Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-105.009 249.318C-118.232 212.989 -99.5006 172.82 -63.1722 159.598L54.2894 116.845C90.6179 103.623 130.787 122.354 144.009 158.682V158.682C157.232 195.011 138.501 235.18 102.172 248.402L-15.2894 291.155C-51.6179 304.377 -91.7868 285.646 -105.009 249.318V249.318Z",
    fill: "#776EFF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-105.009 249.318M144.009 158.682M144.009 158.682M-105.009 249.318M-63.1722 159.598L-62.8302 160.537L54.6314 117.785L54.2894 116.845L53.9474 115.905L-63.5142 158.658L-63.1722 159.598ZM144.009 158.682M102.172 248.402L101.83 247.462L-15.6314 290.215L-15.2894 291.155L-14.9474 292.094L102.514 249.342L102.172 248.402ZM-105.009 249.318M-15.2894 291.155L-15.6314 290.215C-51.4409 303.249 -91.036 284.785 -104.07 248.976L-105.009 249.318L-105.949 249.66C-92.5376 286.507 -51.7948 305.506 -14.9474 292.094L-15.2894 291.155ZM144.009 158.682L143.07 159.024C156.103 194.834 137.64 234.429 101.83 247.462L102.172 248.402L102.514 249.342C139.362 235.931 158.36 195.188 144.949 158.34L144.009 158.682ZM54.2894 116.845L54.6314 117.785C90.4409 104.751 130.036 123.215 143.07 159.024L144.009 158.682L144.949 158.34C131.538 121.493 90.7948 102.494 53.9474 115.905L54.2894 116.845ZM-63.1722 159.598L-63.5142 158.658C-100.362 172.069 -119.36 212.812 -105.949 249.66L-105.009 249.318L-104.07 248.976C-117.103 213.166 -98.6396 173.571 -62.8302 160.537L-63.1722 159.598Z",
    fill: "white",
    fillOpacity: 0.45,
    mask: "url(#path-3-inside-1_5014_35708)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_5014_35708",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-72.3662 237.621C-82.7552 209.077 -68.0379 177.515 -39.4941 167.126L63.8721 129.504C92.4158 119.115 123.977 133.832 134.366 162.376V162.376C144.755 190.92 130.038 222.481 101.494 232.87L-1.87196 270.493C-30.4157 280.882 -61.9771 266.164 -72.3662 237.621V237.621Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-72.3662 237.621C-82.7552 209.077 -68.0379 177.515 -39.4941 167.126L63.8721 129.504C92.4158 119.115 123.977 133.832 134.366 162.376V162.376C144.755 190.92 130.038 222.481 101.494 232.87L-1.87196 270.493C-30.4157 280.882 -61.9771 266.164 -72.3662 237.621V237.621Z",
    fill: "#776EFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-72.3662 237.621M134.366 162.376M134.366 162.376M-72.3662 237.621M-39.4941 167.126L-39.1521 168.066L64.2141 130.444L63.8721 129.504L63.53 128.565L-39.8362 166.187L-39.4941 167.126ZM134.366 162.376M101.494 232.87L101.152 231.931L-2.21398 269.553L-1.87196 270.493L-1.52994 271.432L101.836 233.81L101.494 232.87ZM-72.3662 237.621M-1.87196 270.493L-2.21398 269.553C-30.2388 279.753 -61.2263 265.303 -71.4265 237.279L-72.3662 237.621L-73.3058 237.963C-62.7279 267.025 -30.5927 282.01 -1.52994 271.432L-1.87196 270.493ZM134.366 162.376L133.427 162.718C143.627 190.743 129.177 221.731 101.152 231.931L101.494 232.87L101.836 233.81C130.899 223.232 145.884 191.097 135.306 162.034L134.366 162.376ZM63.8721 129.504L64.2141 130.444C92.2389 120.244 123.226 134.693 133.427 162.718L134.366 162.376L135.306 162.034C124.728 132.971 92.5928 117.987 63.53 128.565L63.8721 129.504ZM-39.4941 167.126L-39.8362 166.187C-68.8989 176.765 -83.8838 208.9 -73.3058 237.963L-72.3662 237.621L-71.4265 237.279C-81.6266 209.254 -67.1769 178.266 -39.1521 168.066L-39.4941 167.126Z",
    fill: "#DAD7FE",
    mask: "url(#path-5-inside-2_5014_35708)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5014_35708)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-3_5014_35708",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.916 111.688C18.7678 106.286 22.2162 100.975 27.6184 99.8271L41.3125 96.9164C46.7146 95.7681 52.0248 99.2166 53.1731 104.619L56.0838 118.313C57.2321 123.715 53.7836 129.025 48.3815 130.173L34.6874 133.084C29.2852 134.232 23.9751 130.784 22.8268 125.382L19.916 111.688Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.916 111.688C18.7678 106.286 22.2162 100.975 27.6184 99.8271L41.3125 96.9164C46.7146 95.7681 52.0248 99.2166 53.1731 104.619L56.0838 118.313C57.2321 123.715 53.7836 129.025 48.3815 130.173L34.6874 133.084C29.2852 134.232 23.9751 130.784 22.8268 125.382L19.916 111.688Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6184 99.8271L27.8263 100.805L41.5204 97.8945L41.3125 96.9164L41.1045 95.9382L27.4105 98.849L27.6184 99.8271ZM53.1731 104.619L52.1949 104.827L55.1057 118.521L56.0838 118.313L57.062 118.105L54.1512 104.411L53.1731 104.619ZM48.3815 130.173L48.1735 129.195L34.4795 132.106L34.6874 133.084L34.8953 134.062L48.5894 131.152L48.3815 130.173ZM22.8268 125.382L23.8049 125.174L20.8942 111.48L19.916 111.688L18.9379 111.896L21.8487 125.59L22.8268 125.382ZM34.6874 133.084L34.4795 132.106C29.6175 133.139 24.8384 130.036 23.8049 125.174L22.8268 125.382L21.8487 125.59C23.1117 131.532 28.9529 135.325 34.8953 134.062L34.6874 133.084ZM56.0838 118.313L55.1057 118.521C56.1391 123.383 53.0355 128.162 48.1735 129.195L48.3815 130.173L48.5894 131.152C54.5317 129.888 58.3251 124.047 57.062 118.105L56.0838 118.313ZM41.3125 96.9164L41.5204 97.8945C46.3823 96.8611 51.1615 99.9647 52.1949 104.827L53.1731 104.619L54.1512 104.411C52.8881 98.4684 47.0469 94.6751 41.1045 95.9382L41.3125 96.9164ZM27.6184 99.8271L27.4105 98.849C21.4681 100.112 17.6748 105.953 18.9379 111.896L19.916 111.688L20.8942 111.48C19.8607 106.618 22.9644 101.839 27.8263 100.805L27.6184 99.8271Z",
    fill: "white",
    fillOpacity: 0.16,
    mask: "url(#path-7-inside-3_5014_35708)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8732 111.62L33.6653 110.642C33.5826 110.253 33.6578 109.847 33.8745 109.513C34.0912 109.18 34.4315 108.946 34.8206 108.863L38.4072 108.101C38.7963 108.018 39.2024 108.093 39.536 108.31C39.8697 108.527 40.1036 108.867 40.1863 109.256L40.3942 110.234M31.2802 113.449L43.507 110.85L45.2396 119.002C45.3085 119.326 45.2458 119.664 45.0653 119.942C44.8847 120.22 44.6011 120.415 44.2768 120.484L34.4953 122.563C34.1711 122.632 33.8327 122.57 33.5546 122.389C33.2766 122.208 33.0817 121.925 33.0128 121.601L31.2802 113.449Z",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white",
    strokeOpacity: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9731 116.703C35.9928 117.979 41.0466 116.904 44.2 114.104M36.6296 116.565L39.8901 115.872",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    stroke: "white",
    strokeOpacity: 0.92
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-4_5014_35708",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99735 81.1027C11.2871 66.9757 27.8382 60.6223 41.9653 66.9121L139.715 110.433C176.041 126.607 192.378 169.167 176.205 205.493L160.749 240.208C156.256 250.299 144.434 254.837 134.343 250.344L-7.25639 187.3C-23.4016 180.112 -30.6626 161.196 -23.4743 145.051L4.99735 81.1027Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.99735 81.1027C11.2871 66.9757 27.8382 60.6223 41.9653 66.9121L139.715 110.433C176.041 126.607 192.378 169.167 176.205 205.493L160.749 240.208C156.256 250.299 144.434 254.837 134.343 250.344L-7.25639 187.3C-23.4016 180.112 -30.6626 161.196 -23.4743 145.051L4.99735 81.1027Z",
    fill: "url(#paint1_linear_5014_35708)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99735 81.1027C11.2871 66.9757 27.8382 60.6223 41.9653 66.9121L139.715 110.433C176.041 126.607 192.378 169.167 176.205 205.493L160.749 240.208C156.256 250.299 144.434 254.837 134.343 250.344L-7.25639 187.3C-23.4016 180.112 -30.6626 161.196 -23.4743 145.051L4.99735 81.1027Z",
    fill: "#776EFF",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9653 66.9121L41.5585 67.8256L139.308 111.346L139.715 110.433L140.121 109.519L42.372 65.9985L41.9653 66.9121ZM176.205 205.493L175.291 205.087L159.835 239.801L160.749 240.208L161.662 240.615L177.118 205.9L176.205 205.493ZM134.343 250.344L134.75 249.431L-6.84966 186.386L-7.25639 187.3L-7.66313 188.213L133.936 251.258L134.343 250.344ZM-23.4743 145.051L-22.5607 145.458L5.91089 81.5094L4.99735 81.1027L4.0838 80.696L-24.3878 144.644L-23.4743 145.051ZM-7.25639 187.3L-6.84966 186.386C-22.4903 179.423 -29.5244 161.098 -22.5607 145.458L-23.4743 145.051L-24.3878 144.644C-31.8007 161.294 -24.3129 180.801 -7.66313 188.213L-7.25639 187.3ZM160.749 240.208L159.835 239.801C155.567 249.387 144.336 253.699 134.75 249.431L134.343 250.344L133.936 251.258C144.532 255.975 156.945 251.21 161.662 240.615L160.749 240.208ZM139.715 110.433L139.308 111.346C175.13 127.296 191.24 169.264 175.291 205.087L176.205 205.493L177.118 205.9C193.517 169.069 176.953 125.918 140.121 109.519L139.715 110.433ZM41.9653 66.9121L42.372 65.9985C27.7404 59.4841 10.5982 66.0644 4.0838 80.696L4.99735 81.1027L5.91089 81.5094C11.976 67.8869 27.936 61.7605 41.5585 67.8256L41.9653 66.9121Z",
    fill: "white",
    fillOpacity: 0.34,
    mask: "url(#path-11-inside-4_5014_35708)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_5014_35708",
    x: -81.7151,
    y: 5.85938,
    width: 291.43,
    height: 243.281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5014_35708"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_5014_35708",
    x: -125,
    y: -31,
    width: 378,
    height: 318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42,
    result: "effect1_foregroundBlur_5014_35708"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5014_35708",
    x: 1.83691,
    y: 81.8359,
    width: 72.3259,
    height: 72.3281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.298039 0 0 0 0 0.266667 0 0 0 0 0.745098 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5014_35708"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "BackgroundImageFix",
    in2: "effect1_dropShadow_5014_35708",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5014_35708",
    x1: -21.8104,
    y1: 12.9107,
    x2: 25.1975,
    y2: 265.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#857EFF",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#857EFF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6860EE",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5014_35708",
    x1: 16.386,
    y1: 55.5234,
    x2: 47.5222,
    y2: 273.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABA6FF",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7A73F3",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6860EE",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5014_35708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 310,
    height: 205,
    fill: "white",
    transform: "translate(-61)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveNotificationBgShape);
export default __webpack_public_path__ + "static/media/live_notification_BG_shape.2bf1a38ebb1f71632c82db7d76199426.svg";
export { ForwardRef as ReactComponent };